import { IProductDefinition } from '@ads/front-core/products/IProductDefinition'
import { EyeDotted } from '@ads/front-core/Icons/wizard'
import { lng } from '@ads/front-core/locales'
import limits from '@ads/front-core/constants/limits'
import { ProductFor, WizardSubCategoryEnum } from '@ads/front-core/interfaces'
import { campaignMaxDateByDays } from './utils'

export const OUTSTREAM_VIDEO_VCPM: IProductDefinition = {
  productTypeId: 'OUTSTREAM_VIDEO_VCPM',
  productAvailableFor: [ProductFor.NONPUBLISHER],
  createUrl: '/campaign/create/outstream-in-banner-vcpm/',
  title: 'campaign:outstreamInBanner.title',
  titleForAdmin: 'Video outstream in-banner (vCPM)',
  budget: {
    model: 'VCPM',
    type: 'TOTAL',
    variant: 'ANY',
    disableDailyLimit: true,
    validation: {
      globalLimit: {
        min: limits.OUTSTREAM_IN_BANNER_MIN_TOTAL,
      },
      rate: {
        min: limits.OUTSTREAM_IN_BANNER_MIN_RATE_VCPM,
      },
    },
  },
  campaignMinimumRates: {
    fields: ['DEFAULT'],
    inputType: 'number',
  },
  campaignMaxDate: campaignMaxDateByDays(90),
  allowedCreationTypes: ['OUTSTREAM_VIDEO'],
  creationsDescription: {
    description: 'campaign:outstreamInBanner.creations.titleDescription',
  },
  targeting: {
    countries: true,
    demography: true,
    devices: true,
    locations: true,
    emitToTrusted: true,
    segmentsTab: ['segments', 'retargetingSegments'],
  },
  wizard: {
    subCategory: WizardSubCategoryEnum.OUTSTREAM_IN_BANNER,
    productDescription: {
      title: lng('wizard:numberOfViews'),
      description: lng('wizard:displayVCPMDescription'),
      Icon: EyeDotted,
    },
    parameters: [
      {
        label: lng('campaign:billingModel'),
        value: lng('wizard:budgetModel.vcpm'),
      },
      {
        label: lng('wizard:destination'),
        value: lng('wizard:buildingAwarenessReach'),
      },
    ],
  },
}
